export enum Origin {
	AA = 1,
	APP = 2,
	AC = 3,
	CR = 4
}
